'use strict';

var dictionary = {
  '3': 'P03',
  '6': 'P06',
  '9': 'P09',
  '12': 'P12'
};

module.exports = function (key) {
  return dictionary[key];
};
